import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  BooleanField,
  SelectInput,
  FilterButton,
  TopToolbar,
  ExportButton,
  NumberInput,
  FunctionField,
} from 'react-admin';
import { Chip } from '@mui/material';

const betFilters = [
  <NumberInput key="user_id" source="user_id" label="User ID" />,
  <NumberInput key="event_id" source="event_id" label="Event ID" />,
  <NumberInput key="chat_id" source="chat_id" label="Chat ID" />,
  <SelectInput
    key="token"
    source="token"
    choices={[
      { id: 'TON', name: 'TON' },
      { id: 'USDT', name: 'USDT' },
      { id: 'BTC', name: 'BTC' },
      { id: 'ETH', name: 'ETH' },
    ]}
    label="Token"
  />,
  <SelectInput
    key="is_win"
    source="is_win"
    choices={[
      { id: 'true', name: 'Win' },
      { id: 'false', name: 'Loss' },
    ]}
    label="Result"
  />,
];

const BetListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

const WinLossField = ({ source }: { source: string }) => (
  <FunctionField
    source={source}
    render={(record: any) => {
      const isWin = record[source];
      return (
        <Chip
          label={isWin ? 'WIN' : 'LOSS'}
          color={isWin ? 'success' : 'error'}
          size="small"
        />
      );
    }}
  />
);

const TokenField = ({ source }: { source: string }) => (
  <FunctionField
    source={source}
    render={(record: any) => {
      const token = record[source];
      let color: 'default' | 'primary' | 'secondary' | 'info' = 'default';

      switch (token) {
        case 'TON':
          color = 'primary';
          break;
        case 'USDT':
          color = 'secondary';
          break;
        case 'BTC':
        case 'ETH':
          color = 'info';
          break;
        default:
          color = 'default';
      }

      return <Chip label={token} color={color} size="small" />;
    }}
  />
);

export const BetList = () => (
  <List
    filters={betFilters}
    actions={<BetListActions />}
    perPage={50}
    sort={{ field: 'created_at', order: 'DESC' }}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="bet_id" label="Bet ID" />
      <TextField source="user_id" label="User" />
      <TextField source="event_id" label="Event" />
      <TextField source="chat_id" label="Chat" />
      <TokenField source="token" />
      <NumberField
        source="bet_amount"
        options={{ minimumFractionDigits: 2, maximumFractionDigits: 4 }}
        label="Bet Amount"
      />
      <NumberField
        source="bet_amount_usd"
        options={{ style: 'currency', currency: 'USD' }}
        label="Bet (USD)"
      />
      <WinLossField source="is_win" />
      <NumberField
        source="win_amount_usd"
        options={{ style: 'currency', currency: 'USD' }}
        label="Win (USD)"
      />
      <NumberField
        source="points_earned"
        options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
        label="Points"
      />
      <DateField source="created_at" showTime label="Date" />
    </Datagrid>
  </List>
);
